import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0756241d"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "umt-flow-nav d-flex align-items-center flex-wrap gap-2"
}
const _hoisted_2 = { class: "text-gray-500 fw-bold text-uppercase fs-8 text-nowrap" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "umt-flow-nav__div" }, null, -1))
const _hoisted_4 = {
  key: 0,
  class: "bi bi-chevron-right text-gray-400 fs-9"
}
const _hoisted_5 = {
  key: 1,
  class: "badge badge-primary text-nowrap"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_ctx.items.length)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.flowTitle), 1),
        _hoisted_3,
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item, index) => {
          return (_openBlock(), _createElementBlock(_Fragment, {
            key: item.to
          }, [
            index
              ? (_openBlock(), _createElementBlock("i", _hoisted_4))
              : _createCommentVNode("", true),
            (index === _ctx.current)
              ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(index + 1) + ". " + _toDisplayString(item.label), 1))
              : (_openBlock(), _createBlock(_component_router_link, {
                  key: 2,
                  to: item.to,
                  class: "text-gray-700 fw-semibold fs-8 text-hover-primary text-nowrap"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(index + 1) + ". " + _toDisplayString(item.label), 1)
                  ]),
                  _: 2
                }, 1032, ["to"]))
          ], 64))
        }), 128))
      ]))
    : _createCommentVNode("", true)
}